import React from 'react';
import { Star, Heart, Users, Zap } from 'lucide-react';

const OurStory = () => {
  return (
    <section id="story" className="py-20 bg-deepBrown text-warmCream">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="aspect-[4/3] bg-warmBrown rounded-lg overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_melanin-standard/artifacts/ai1zrupa_IMG_0502.jpeg"
                alt="Brianna Marie - #Brownishh Founder"
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Decorative elements */}
            <div className="absolute -top-6 -left-6 w-12 h-12 border-2 border-goldAccent rounded-full"></div>
            <div className="absolute -bottom-6 -right-6 w-8 h-8 bg-goldAccent rounded-full"></div>
            
            {/* Founder Badge */}
            <div className="absolute top-6 right-6 bg-warmCream/95 backdrop-blur-sm rounded-lg p-4 text-richBrown max-w-[200px]">
              <div className="text-center">
                <div className="text-sm font-bold text-goldAccent mb-1">FOUNDER</div>
                <div className="text-lg font-black">Brianna Marie</div>
                <div className="text-xs">Creative Latina</div>
              </div>
            </div>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-4">
              <Heart className="w-6 h-6 text-goldAccent" />
              <span className="text-goldAccent font-bold text-sm tracking-widest uppercase">Why We Exist</span>
            </div>
            
            <h2 className="text-4xl sm:text-5xl font-black mb-8 tracking-tight leading-tight">
              The
              <br />
              <span className="text-goldAccent">Standard</span>
            </h2>
            
            <div className="space-y-6 text-warmCream/95 leading-relaxed text-lg">
              <p>
                <strong className="text-goldAccent">#Brownishh</strong> started with a creative Latina, 
                <strong className="text-warmCream"> Brianna Marie</strong>, who was done searching for beauty 
                and streetwear that actually celebrated brown skin—every shade, every tone, every story.
              </p>
              
              <p>
                The system told us we weren't the standard. That our melanin needed "fixing." 
                That our culture was a trend to be borrowed—not a heritage to be respected.
              </p>
              
              <p className="text-goldAccent font-bold text-xl">
                So we said: <em>no more</em>.
              </p>
              
              <p>
                This isn't just a brand. It's the radical act of showing up exactly as you are.
              </p>
              
              <p>
                It's gold hoops with history. Sweatsuits with presence.
              </p>
              
              <p>
                It's neutral glam and lashes made for our skin—not against it.
              </p>
              
              <p className="font-bold text-xl text-goldAccent">
                We're not waiting for permission. We are the standard.
              </p>
            </div>

            <div className="grid grid-cols-3 gap-6 mt-8 pt-8 border-t border-goldAccent/20">
              <div className="text-center">
                <Zap className="w-8 h-8 text-goldAccent mx-auto mb-2" />
                <div className="text-2xl font-bold text-goldAccent">Bold</div>
                <div className="text-sm opacity-80">Unapologetic</div>
              </div>
              <div className="text-center">
                <Users className="w-8 h-8 text-goldAccent mx-auto mb-2" />
                <div className="text-2xl font-bold text-goldAccent">Brown</div>
                <div className="text-sm opacity-80">Every Shade</div>
              </div>
              <div className="text-center">
                <Heart className="w-8 h-8 text-goldAccent mx-auto mb-2" />
                <div className="text-2xl font-bold text-goldAccent">Unbothered</div>
                <div className="text-sm opacity-80">Authentic</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStory;